import styled, { css } from 'styled-components';
import ChevronDown from '../../../assets/icons/ChevronDown.svg';
import { select } from '../../../core/themev2';
import { getColor } from '../../../core/themev3';

const HeaderContainter = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border: 1px solid ${({ isOpen, borderColor }) => (isOpen ? getColor('primary') : select(borderColor))};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  ${({ isMenu }) =>
    isMenu &&
    css`
      border: none !important;
      border-bottom: 1px solid ${({ isOpen }) => (isOpen ? getColor('primary') : select('middleGray'))}!important;
      border-radius: 0 !important;
    `}
`;

const Ask = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-weight: 400;
  color: ${({ textColor }) => select(textColor)};
  width: fit-content;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: ${({ marginTop }) => marginTop};
  margin-left: ${({ marginLeft }) => marginLeft};
  @media (max-width: 1024px) {
    height: fit-content;
    font-size: 14px;
    line-height: 23.4px;
    font-weight: ${({ isMenu }) => (isMenu ? '600' : '400')};
    text-align: center;
  }
  @media (max-width: 770px) {
    height: fit-content;
    font-size: 14px;
    line-height: 23.4px;
    font-weight: ${({ isMenu }) => (isMenu ? '600' : '400')};
  }
`;

const Chevron = styled.button`
  background-image: ${`url(${ChevronDown})`};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 8px;
  margin-left: 5px;
  margin-bottom: 14px;
  align-self: flex-end;
  cursor: pointer;
  transform: ${({ isOpen }) => `rotateX(${isOpen ? '180deg' : '0deg'})`};
  transition: all 0.4s ease;
`;
export { HeaderContainter, Ask, Chevron };
